import { shallowEqual } from './object'
import { createSelectorCreator, defaultMemoize } from './selectors-lib'

export const createSelector = createSelectorCreator(defaultMemoize)

export const createPropSelector = (caseSelector, propName, fallback) =>
  createSelector(caseSelector, data =>
    data.hasOwnProperty(propName) ? data[propName] : fallback
  )

export const createSelectorForProps = (caseSelector, propNames, resultFn) =>
  createSelector(
    ...propNames.map(name => createPropSelector(caseSelector, name)),
    resultFn
  )

export const arraySum = arr => arr.reduce((res, entry) => res + entry, 0)

export const arrayAverage = arr =>
  arr.length ? arraySum(arr) / arr.length : null

/**
 * Creates a memoized version of a function with a shallow equality check on arguments.
 *
 * @template T - This represents a generic function type.
 * @param {T} func - The function to memoize.
 * @returns {T} - Returns the new memoized function.
 */
export const shallowEqualMemoize = func => defaultMemoize(func, shallowEqual)
